window.ZAUN_DATA = {
    "version":  1,
    "waehrung":  "EUR",
    "grenzen":  {
                    "min_laenge_m":  1.5,
                    "max_laenge_m":  100,
                    "max_gefaelle_pct":  35,
                    "stufen_hinweis_ab_cm":  30,
                    "max_hoehe_auf_anfrage_cm":  150,
                    "langgut_ab_cm":  240
                },
    "feldlaengen_cm":  [
                           200,
                           230,
                           250
                       ],
    "lieferarten":  [
                        {
                            "id":  "vormontiert",
                            "name":  "Fertig montierte Felder",
                            "beschreibung":  "Die Zaunfelder kommen komplett verschraubt – auspacken, an die Pfosten schrauben, fertig."
                        },
                        {
                            "id":  "bausatz",
                            "name":  "Einzelteile (Bausatz)",
                            "beschreibung":  "Latten, Riegel und Schrauben kommen lose. Beim Aufbau bist du flexibler – z. B. am Hang oder bei Sondermaßen.",
                            "vorteil":  "Günstiger, weil die Montage entfällt"
                        }
                    ],
    "modelle":  [
                    {
                        "id":  "senkr_lattenzaun_2c",
                        "modell_db":  "Senkr_Lattenzaun",
                        "ausfuehrung":  "2C",
                        "latten_name":  "Senkrechter_Lattenzaun_2C",
                        "riegel_name":  "Querriegel_B",
                        "name":  "Senkrechter Lattenzaun 2C",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Der Klassiker: senkrechte Halbrundlatten (6,4 cm) mit gespitzten Köpfen auf halbrunden Querriegeln.",
                        "bild_url":  "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250514_175017_cr_4fe40f8d-da01-4092-8038-4f59848c4067.jpg?width=600",
                        "bilder":  [
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250514_175017_cr_4fe40f8d-da01-4092-8038-4f59848c4067.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250514_175017.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/senk_hobellattenzaun_2c_eb03b1a7-3a20-4007-8395-fa734db0ddea.jpg?width=1200"
                                   ],
                        "sortierung":  1,
                        "skizze":  {
                                       "kopf":  "spitz",
                                       "spitzeFaktor":  0.9,
                                       "profil":  "rund",
                                       "riegel":  "rund"
                                   }
                    },
                    {
                        "id":  "senkr_lattenzaun_3e",
                        "modell_db":  "Senkr_Lattenzaun",
                        "ausfuehrung":  "3E",
                        "latten_name":  "Senkrechter_Lattenzaun_3E",
                        "riegel_name":  "Querriegel_B",
                        "name":  "Senkrechter Lattenzaun 3E",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Senkrechter Lattenzaun 3E: dichte Rundlatten mit schräg geschnittenen Köpfen.",
                        "bild_url":  "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/s-l1600-1.webp?width=600",
                        "bilder":  [
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/s-l1600-1.webp?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/senk_hobellattenzaun_3e_jpg_708d4aa3-b8be-4922-b5a2-5efbb7ba93ef.jpg?width=1200"
                                   ],
                        "sortierung":  2,
                        "skizze":  {
                                       "kopf":  "schraeg",
                                       "profil":  "rund",
                                       "riegel":  "rund"
                                   }
                    },
                    {
                        "id":  "quadratzaun_4k",
                        "modell_db":  "Quadratzaun",
                        "ausfuehrung":  "4K",
                        "latten_name":  "Quadratzaun_4K",
                        "riegel_name":  "Vierkantriegel_A",
                        "name":  "Quadratzaun 4K",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Moderne, feine Optik: schmale quadratische Latten (3,5 cm) mit gleichmäßigen Abständen.",
                        "bild_url":  "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/zaunfeld_fichte_kdi_quadrat.png?width=600",
                        "bilder":  [
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/zaunfeld_fichte_kdi_quadrat.png?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Quadratzaun_fichte.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Qudaratzaun_Fichte_KDI_3.png?width=1200"
                                   ],
                        "sortierung":  3,
                        "skizze":  {
                                       "kopf":  "flach",
                                       "profil":  "eckig",
                                       "riegel":  "flach"
                                   }
                    },
                    {
                        "id":  "quadratzaun_32a",
                        "modell_db":  "Quadratzaun",
                        "ausfuehrung":  "32A",
                        "latten_name":  "Quadratzaun_Laerche_32A",
                        "riegel_name":  "Vierkantriegel_Laerche_LV",
                        "name":  "Quadratzaun 32A (Lärche)",
                        "material":  "Lärche",
                        "beschreibung":  "Quadratzaun aus unbehandelter Lärche – von Natur aus dauerhaft, vergraut edel silbergrau.",
                        "bild_url":  "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Zaunfeld_Laerche.png?width=600",
                        "bilder":  [
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Zaunfeld_Laerche.png?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/zaunfeld_quadratzaun_laerche.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20240513_125527.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20240513_125701_cr.jpg?width=1200"
                                   ],
                        "sortierung":  4,
                        "skizze":  {
                                       "kopf":  "flach",
                                       "profil":  "eckig",
                                       "riegel":  "flach"
                                   }
                    },
                    {
                        "id":  "hobellattenzaun_12a",
                        "modell_db":  "Hobellattenzaun",
                        "ausfuehrung":  "12A",
                        "latten_name":  "Hobellattenzaun_12A",
                        "riegel_name":  "Vierkantriegel_A",
                        "name":  "Hobellattenzaun 12A",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Breite, gehobelte Latten (6,5 cm) für eine ruhige, halbgeschlossene Optik.",
                        "bild_url":  "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250720_141724_cr.png?width=600",
                        "bilder":  [
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250720_141724_cr.png?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Hobellattenzaun_12A_1_9150b360-c89f-443b-96ea-8fd718801256.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Hobellattenzaun_12A_2_9823b506-5d0c-4bfc-b4ca-ba108616c903.jpg?width=1200"
                                   ],
                        "sortierung":  5,
                        "skizze":  {
                                       "kopf":  "flach",
                                       "profil":  "eckig",
                                       "riegel":  "flach"
                                   }
                    },
                    {
                        "id":  "knueppelzaun_1r",
                        "modell_db":  "Knuepellzaun",
                        "ausfuehrung":  "1R",
                        "latten_name":  "Knueppelzaun_1R",
                        "riegel_name":  "Querriegel_B",
                        "name":  "Knüppelzaun 1R",
                        "material":  "Fichte KDI",
                        "beschreibung":  "Rustikaler Bauernzaun aus gespitzten Knüppellatten – der Charakterzaun.",
                        "bild_url":  "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/s-l1600_cr.jpg?width=600",
                        "bilder":  [
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/s-l1600_cr.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Knueppelzaun_818425f8-16a1-48bf-9c51-d469db040532.jpg?width=1200",
                                       "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Knueppelzaun_1_8268723b-4dcf-4c51-9f49-4ab0b17bdbdd.jpg?width=1200"
                                   ],
                        "sortierung":  6,
                        "skizze":  {
                                       "kopf":  "spitz",
                                       "spitzeFaktor":  1.2,
                                       "profil":  "rund",
                                       "riegel":  "rund"
                                   }
                    }
                ],
    "befestigungen":  [
                          {
                              "id":  "einbetonieren",
                              "name":  "Einbetonieren",
                              "beschreibung":  "Die Pfostenverankerung wird einbetoniert – der Standard bei Aufbau im Erdreich.",
                              "details":  [
                                              "Loch ausheben (ca. 40 × 40 × 60 cm) und die Verankerung einbetonieren – je nach Pfostensystem ein T-Eisen (IPF), ein H-Steg-Träger oder der T-Eisenpfosten selbst.",
                                              "Das Holz endet über dem Boden und hat keinen Erdkontakt – es kann nicht von unten faulen.",
                                              "Geeignet für Rasen, Beet und offenes Erdreich."
                                          ]
                          },
                          {
                              "id":  "aufduebeln",
                              "name":  "Aufdübeln",
                              "beschreibung":  "Die Pfostenverankerung wird auf Fundament, Mauer oder Beton gedübelt – ganz ohne Graben und Betonieren.",
                              "details":  [
                                              "Bodenplatte mit Schwerlastdübeln auf den Untergrund dübeln – je nach Pfostensystem mit T-Eisen (IPF), Dübelplatten-Halter oder T-Eisenpfosten mit Fußplatte.",
                                              "Voraussetzung: tragfähiger, ebener Untergrund (Betonfundament, Mauerkrone, Randstein).",
                                              "Kein Graben, kein Betonieren – auch nachträglich montierbar."
                                          ]
                          },
                          {
                              "id":  "vorhanden",
                              "name":  "Pfosten existieren bereits",
                              "ohne_pfosten":  true,
                              "beschreibung":  "Du hast schon stabile Pfosten (z. B. vom alten Zaun)? Dann bestellst du nur die Zaunfelder.",
                              "details":  [
                                              "Es kommen keine Pfosten und Kappen auf die Stückliste – du zahlst nur die Felder.",
                                              "Wichtig: Miss die lichte Weite zwischen deinen Pfosten. Die Felder sind 200, 230 oder 250 cm lang und können vor Ort gekürzt werden.",
                                              "Die vorhandenen Pfosten sollten mindestens so hoch wie der neue Zaun und fest verankert sein."
                                          ]
                          }
                      ],
    "pfosten_auswahl":  [
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "einbetonieren",
                                "system":  "ipf",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Holzpfosten_VS10_T",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Zaunpfosten Fichte KDI 9 × 9 cm, IPF mit T-Eisen",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "einbetonieren",
                                "system":  "ipf",
                                "bis_hoehe_cm":  120,
                                "ausfuehrung":  "Holzpfosten_VS12_T",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Zaunpfosten Fichte KDI 11 × 11 cm, IPF mit T-Eisen",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "einbetonieren",
                                "system":  "halter",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Vierkantholzpfosten_V10",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Vierkantholzpfosten Fichte KDI 9 × 9 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_HS_9_60",
                                "halter_anzeige":  "H-Steg-Pfostenträger für 9er-Pfosten, feuerverzinkt (einbetonieren)",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "einbetonieren",
                                "system":  "halter",
                                "bis_hoehe_cm":  999,
                                "ausfuehrung":  "Vierkantholzpfosten_V12",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Vierkantholzpfosten Fichte KDI 11 × 11 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_HS_11_60",
                                "halter_anzeige":  "H-Steg-Pfostenträger für 11er-Pfosten, feuerverzinkt (einbetonieren)",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "aufduebeln",
                                "system":  "ipf",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Holzpfosten_VS10_D",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Zaunpfosten Fichte KDI 9 × 9 cm, IPF mit Dübelplatte",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "aufduebeln",
                                "system":  "ipf",
                                "bis_hoehe_cm":  120,
                                "ausfuehrung":  "Holzpfosten_VS12_D",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Zaunpfosten Fichte KDI 11 × 11 cm, IPF mit Dübelplatte",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "aufduebeln",
                                "system":  "halter",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Vierkantholzpfosten_V10",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Vierkantholzpfosten Fichte KDI 9 × 9 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_DUP_90",
                                "halter_anzeige":  "Dübelplatten-Pfostenhalter für 9er-Pfosten, feuerverzinkt",
                                "annahme":  true
                            },
                            {
                                "material":  "Fichte KDI",
                                "befestigung":  "aufduebeln",
                                "system":  "halter",
                                "bis_hoehe_cm":  999,
                                "ausfuehrung":  "Vierkantholzpfosten_V12",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Vierkantholzpfosten Fichte KDI 11 × 11 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_DUP_110",
                                "halter_anzeige":  "Dübelplatten-Pfostenhalter für 11er-Pfosten, feuerverzinkt",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "einbetonieren",
                                "system":  "ipf",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Zaunpfosten Lärche 9 × 9 cm, IPF mit T-Eisen",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "einbetonieren",
                                "system":  "ipf",
                                "bis_hoehe_cm":  120,
                                "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Zaunpfosten Lärche 11 × 11 cm, IPF mit T-Eisen",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "einbetonieren",
                                "system":  "halter",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Vierkantholzpfosten Lärche 9 × 9 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_HS_9_60",
                                "halter_anzeige":  "H-Steg-Pfostenträger für 9er-Pfosten, feuerverzinkt (einbetonieren)",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "einbetonieren",
                                "system":  "halter",
                                "bis_hoehe_cm":  999,
                                "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Vierkantholzpfosten Lärche 11 × 11 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_HS_11_60",
                                "halter_anzeige":  "H-Steg-Pfostenträger für 11er-Pfosten, feuerverzinkt (einbetonieren)",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "aufduebeln",
                                "system":  "ipf",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Zaunpfosten Lärche 9 × 9 cm, IPF mit Dübelplatte",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "aufduebeln",
                                "system":  "ipf",
                                "bis_hoehe_cm":  120,
                                "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Zaunpfosten Lärche 11 × 11 cm, IPF mit Dübelplatte",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "aufduebeln",
                                "system":  "halter",
                                "bis_hoehe_cm":  100,
                                "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                                "querschnitt_cm":  9.2,
                                "anzeige":  "Vierkantholzpfosten Lärche 9 × 9 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_DUP_90",
                                "halter_anzeige":  "Dübelplatten-Pfostenhalter für 9er-Pfosten, feuerverzinkt",
                                "annahme":  true
                            },
                            {
                                "material":  "Lärche",
                                "befestigung":  "aufduebeln",
                                "system":  "halter",
                                "bis_hoehe_cm":  999,
                                "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                                "querschnitt_cm":  11.2,
                                "anzeige":  "Vierkantholzpfosten Lärche 11 × 11 cm",
                                "halter_ausfuehrung":  "Pfostenhalter_DUP_110",
                                "halter_anzeige":  "Dübelplatten-Pfostenhalter für 11er-Pfosten, feuerverzinkt",
                                "annahme":  true
                            },
                            {
                                "material":  "*",
                                "befestigung":  "einbetonieren",
                                "system":  "teisen",
                                "bis_hoehe_cm":  150,
                                "ausfuehrung":  "T-Eisenpfosten_14B",
                                "querschnitt_cm":  5,
                                "laenge_wie_hoehe":  true,
                                "ohne_kappen":  true,
                                "ohne_winkel":  true,
                                "zwischen_feldern":  false,
                                "anzeige":  "T-Eisenpfosten 14B, feuerverzinkt (einbetonieren)",
                                "annahme":  true
                            },
                            {
                                "material":  "*",
                                "befestigung":  "aufduebeln",
                                "system":  "teisen",
                                "bis_hoehe_cm":  150,
                                "ausfuehrung":  "T-Eisenpfosten_14C",
                                "querschnitt_cm":  5,
                                "laenge_wie_hoehe":  true,
                                "ohne_kappen":  true,
                                "ohne_winkel":  true,
                                "zwischen_feldern":  false,
                                "anzeige":  "T-Eisenpfosten 14C, feuerverzinkt (aufdübeln)",
                                "annahme":  true
                            }
                        ],
    "pfostenlaenge_cm":  {
                             "einbetonieren":  {
                                                   "80":  90,
                                                   "100":  110,
                                                   "120":  120,
                                                   "150":  150
                                               },
                             "aufduebeln":  {
                                                "80":  80,
                                                "100":  100,
                                                "120":  120,
                                                "150":  150
                                            }
                         },
    "kappen_auswahl":  [
                           {
                               "querschnitt_cm":  9.2,
                               "sku":  "Pfostenkappe_100x100_FV_Stk",
                               "anzeige":  "Pfostenkappe 100 × 100 mm, feuerverzinkt"
                           },
                           {
                               "querschnitt_cm":  11.2,
                               "sku":  "Pfostenkappe_120x120_FV_Stk",
                               "anzeige":  "Pfostenkappe 120 × 120 mm, feuerverzinkt"
                           }
                       ],
    "winkel_regel":  {
                         "sku":  "Zaunzubehoer_Zaunwinkel_Stk",
                         "anzeige":  "Zaunwinkel für die Riegelbefestigung, feuerverzinkt",
                         "pro_feld":  4,
                         "kommentar":  "Riegel werden mit Zaunwinkeln am Holzpfosten befestigt: 2 Riegel je Feld × 2 Enden = 4 Winkel. Bestätigt am 08.07.2026; bei vorhandenen Pfosten keine Winkel."
                     },
    "pfostensysteme":  [
                           {
                               "id":  "ipf",
                               "name":  "IPF-Systempfosten",
                               "text":  "Holzpfosten mit gefräster Nut auf T-Eisen bzw. Dübelplatte – kein Erdkontakt, unsere Empfehlung bis 120 cm Zaunhöhe.",
                               "bilder":  [
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Pfosten_schraeg_IPF_46b0183b-c5bc-4ccb-b7f2-e5a0588b2536.png?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250919_142136_6.jpg?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250923_110428.jpg?width=1200"
                                          ]
                           },
                           {
                               "id":  "teisen",
                               "name":  "T-Eisenpfosten (Stahl)",
                               "text":  "Schlanker Stahlpfosten, feuerverzinkt – die Zaunfelder werden direkt am T-Eisen verschraubt.",
                               "bilder":  [
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/T-Eisen.png?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250329_170621_cr.jpg?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250329_170629_cr.jpg?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/20250329_170634_cr.jpg?width=1200"
                                          ]
                           },
                           {
                               "id":  "halter",
                               "name":  "Regulärer Pfosten + Halter",
                               "text":  "Vierkantpfosten ohne Nut im passenden Pfostenhalter (H-Steg bzw. Dübelplatte) – auch in langen Längen, gut am Hang und bei hohen Zäunen.",
                               "bilder":  [
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Pfosten_schraeg_40bfdccc-b9cb-4a00-9a5b-e2bd62c7c9a5.png?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/H_Steg_Produktbild.jpg?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Skizze_HSteg.png?width=1200",
                                              "https://cdn.shopify.com/s/files/1/0933/0340/6917/files/Duebelplatte.png?width=1200"
                                          ]
                           }
                       ],
    "massfeld":  {
                     "kommentar":  "Felder nach Maß: alle Felder eines Abschnitts gleich lang, individuell gefertigt wie im Zaunfeld-Konfigurator. Preisformel = parameter, Versandklassen = versand, Warenkorb über die Preisraster-Produkte (handles). hoehen_cm = zusätzlich wählbare Zaunhöhen (erzwingen den Maß-Modus, wenn es kein Lager-Feld gibt).",
                     "min_laenge_cm":  50,
                     "max_laenge_cm":  300,
                     "standard_max_cm":  240,
                     "hoehen_cm":  [
                                       60,
                                       70,
                                       80,
                                       90,
                                       100,
                                       110,
                                       120,
                                       130,
                                       140,
                                       150
                                   ],
                     "handle":  "individuelles-zaunfeld",
                     "handle_langgut":  "individuelles-zaunfeld-langgut"
                 },
    "parameter":  {
                      "kommentar":  "Oeffentliche Datenvariante: Verkaufs-Einzelpreise (Aufschlag bereits eingerechnet).",
                      "riegel_reihen":  2,
                      "schrauben_pro_latte_riegel":  2,
                      "schrauben_preis":  0.092,
                      "schrauben_gewicht_kg":  0.005,
                      "montage_pauschale":  41.055,
                      "zuschnitt_pauschale":  0,
                      "aufschlag_pct":  0,
                      "min_gewinn":  0.0,
                      "preis_raster_eur":  10,
                      "preis_raster_kommentar":  "Shop-Preis wird auf dieses Raster AUFgerundet, damit er als Variante des Preisraster-Produkts abbildbar ist.",
                      "shop_preisaufschlag_faktor":  1.14,
                      "shop_preisaufschlag_kommentar":  "Globaler Marktaufschlag des Shops – nur für die Varianten-CSV relevant, nicht für die Anzeige im Konfigurator."
                  },
    "versand":  {
                    "kommentar":  "Port von classify_shipping() aus dem Cockpit, nur für Felder nach Maß (informativ + Langgut-Erkennung). Ab langgut_ab_cm greift der Langgut-Tarif; im Shop hängt daran das Produkt handle_langgut mit Versandprofil \u0027Langgut\u0027.",
                    "langgut_ab_cm":  240,
                    "kurz_grenze_cm":  190,
                    "mittel_grenze_cm":  240,
                    "umklassifizieren_ab_cm":  240,
                    "umklassifizieren_unter_kg":  80,
                    "ersatz_laenge_cm":  200,
                    "kurz_stufen":  [
                                        {
                                            "max_kg":  31.5,
                                            "kosten":  20,
                                            "art":  "Paketversand (bis 31,5 kg)"
                                        },
                                        {
                                            "max_kg":  60,
                                            "kosten":  40,
                                            "art":  "Spedition (bis 60 kg)"
                                        },
                                        {
                                            "max_kg":  90,
                                            "kosten":  60,
                                            "art":  "Spedition (bis 90 kg)"
                                        },
                                        {
                                            "max_kg":  null,
                                            "kosten":  120,
                                            "art":  "Spedition (ab 90 kg)"
                                        }
                                    ],
                    "mittel":  {
                                   "kosten":  120,
                                   "art":  "Spedition (190–240 cm)"
                               },
                    "lang":  {
                                 "kosten":  193.28,
                                 "art":  "Spedition Langgut (über 240 cm, inkl. Langgutzuschlag)"
                             }
                },
    "annahmen":  [
                     "Wir teilen den Zaun bevorzugt in Felder bis 240 cm – das hält die Versandkosten niedrig.",
                     "Felder nach Maß werden individuell für dich gefertigt; der Preis wird aus Material und Fertigung kalkuliert.",
                     "Wir planen 9×9-cm-Pfosten bis 100 cm Zaunhöhe, darüber 11×11 cm.",
                     "Die Pfostenlängen sind vorläufig kalkuliert – wir prüfen sie vor der Lieferung.",
                     "Am Hang planen wir für Pfosten an den Stufen die nächstlängere Größe ein.",
                     "Je Abschnitt runden wir auf volle Feldlängen auf – das letzte Feld kann vor Ort gekürzt werden.",
                     "Bausatz: 10 % günstiger als fertig montierte Felder (vorläufige Preisregel).",
                     "An jedem Eckpunkt des Zaunverlaufs sitzt ein Pfosten; Felder laufen nicht um Ecken."
                 ],
    "generiert_am":  "2026-07-26",
    "felder":  [
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_80x200",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  80,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 200 cm",
                       "preis":  87.75
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_80x230",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  80,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 230 cm",
                       "preis":  103.00
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_80x250",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  80,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 250 cm",
                       "preis":  109.49
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_100x200",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  100,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 200 cm",
                       "preis":  95.12
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_100x230",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  100,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 230 cm",
                       "preis":  111.00
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_100x250",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  100,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 250 cm",
                       "preis":  120.00
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_120x200",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  120,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 200 cm",
                       "preis":  105.28
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_120x230",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  120,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 230 cm",
                       "preis":  122.00
                   },
                   {
                       "sku":  "Feld_Hobellattenzaun_12A_120x250",
                       "modell":  "Hobellattenzaun",
                       "ausfuehrung":  "12A",
                       "hoehe_cm":  120,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-hobellattenzaun-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 250 cm",
                       "preis":  133.04
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_80x200",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  80,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 200 cm",
                       "preis":  99.50
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_80x230",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  80,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 230 cm",
                       "preis":  118.00
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_80x250",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  80,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 250 cm",
                       "preis":  123.78
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_100x200",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  100,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 200 cm",
                       "preis":  105.12
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_100x230",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  100,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 230 cm",
                       "preis":  120.00
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_100x250",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  100,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 250 cm",
                       "preis":  130.80
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_120x200",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  120,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 200 cm",
                       "preis":  112.48
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_120x230",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  120,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 230 cm",
                       "preis":  130.00
                   },
                   {
                       "sku":  "Feld_Knuepellzaun_1R_120x250",
                       "modell":  "Knuepellzaun",
                       "ausfuehrung":  "1R",
                       "hoehe_cm":  120,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-knuppelzaun-bauernzaun-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 250 cm",
                       "preis":  140.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_80x200",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  80,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-quadratzaun-zaunelement-80-cm-hohe",
                       "option1":  "80 cm x 200 cm",
                       "preis":  144.62
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_80x230",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  80,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-quadratzaun-zaunelement-80-cm-hohe",
                       "option1":  "80 cm x 230 cm",
                       "preis":  170.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_80x250",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  80,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-quadratzaun-zaunelement-80-cm-hohe",
                       "option1":  "80 cm x 250 cm",
                       "preis":  179.49
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_100x200",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  100,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-larche",
                       "option1":  "100 cm x 200 cm",
                       "preis":  160.20
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_100x230",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  100,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-larche",
                       "option1":  "100 cm x 230 cm",
                       "preis":  185.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_100x250",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  100,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-larche",
                       "option1":  "100 cm x 250 cm",
                       "preis":  198.96
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_120x200",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  120,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-quadratzaun-zaunelement-120-cm-hohe",
                       "option1":  "120 cm x 200 cm",
                       "preis":  175.12
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_120x230",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  120,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-quadratzaun-zaunelement-120-cm-hohe",
                       "option1":  "120 cm x 230 cm",
                       "preis":  207.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_32A_120x250",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "32A",
                       "hoehe_cm":  120,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-quadratzaun-zaunelement-120-cm-hohe",
                       "option1":  "120 cm x 250 cm",
                       "preis":  222.42
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_80x200",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  80,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-80-cm-hohe",
                       "option1":  "80 cm x 200 cm",
                       "preis":  106.94
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_80x230",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  80,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-80-cm-hohe",
                       "option1":  "80 cm x 230 cm",
                       "preis":  120.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_80x250",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  80,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-80-cm-hohe",
                       "option1":  "80 cm x 250 cm",
                       "preis":  133.47
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_100x200",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  100,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-100-cm-hohe",
                       "option1":  "100 cm x 200 cm",
                       "preis":  117.55
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_100x230",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  100,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-100-cm-hohe",
                       "option1":  "100 cm x 230 cm",
                       "preis":  138.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_100x250",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  100,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-100-cm-hohe",
                       "option1":  "100 cm x 250 cm",
                       "preis":  148.38
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_120x200",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  120,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-120-cm-hohe",
                       "option1":  "120 cm x 200 cm",
                       "preis":  132.04
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_120x230",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  120,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-120-cm-hohe",
                       "option1":  "120 cm x 230 cm",
                       "preis":  157.00
                   },
                   {
                       "sku":  "Feld_Quadratzaun_4K_120x250",
                       "modell":  "Quadratzaun",
                       "ausfuehrung":  "4K",
                       "hoehe_cm":  120,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-quadratzaun-fichte-kdi-zaunelement-120-cm-hohe",
                       "option1":  "120 cm x 250 cm",
                       "preis":  166.49
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_80x200",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  80,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 200 cm",
                       "preis":  66.12
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_80x230",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  80,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 230 cm",
                       "preis":  76.00
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_80x250",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  80,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement-fichte-kdi-80-cm-hohe",
                       "option1":  "80 cm x 250 cm",
                       "preis":  82.46
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_100x200",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  100,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 200 cm",
                       "preis":  69.81
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_100x230",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  100,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 230 cm",
                       "preis":  82.00
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_100x250",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  100,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement-fichte-kdi-100-cm-hohe",
                       "option1":  "100 cm x 250 cm",
                       "preis":  88.71
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_120x200",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  120,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement",
                       "option1":  "120 cm x 200 cm",
                       "preis":  76.52
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_120x230",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  120,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement",
                       "option1":  "120 cm x 230 cm",
                       "preis":  85.00
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_2C_120x250",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "2C",
                       "hoehe_cm":  120,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-zaunelement",
                       "option1":  "120 cm x 250 cm",
                       "preis":  97.10
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_80x200",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  80,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "80 cm x 200 cm",
                       "preis":  68.50
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_80x230",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  80,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "80 cm x 230 cm",
                       "preis":  79.00
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_80x250",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  80,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "80 cm x 250 cm",
                       "preis":  85.44
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_100x200",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  100,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "100 cm x 200 cm",
                       "preis":  71.54
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_100x230",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  100,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "100 cm x 230 cm",
                       "preis":  83.50
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_100x250",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  100,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "100 cm x 250 cm",
                       "preis":  90.87
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_120x200",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  120,
                       "laenge_cm":  200,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 200 cm",
                       "preis":  77.81
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_120x230",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  120,
                       "laenge_cm":  230,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 230 cm",
                       "preis":  88.00
                   },
                   {
                       "sku":  "Feld_Senkr_Lattenzaun_3E_120x250",
                       "modell":  "Senkr_Lattenzaun",
                       "ausfuehrung":  "3E",
                       "hoehe_cm":  120,
                       "laenge_cm":  250,
                       "handle":  "gartenzaun-senkrechter-lattenzaun-variante-3e-zaunelement-fichte-kdi",
                       "option1":  "120 cm x 250 cm",
                       "preis":  98.71
                   }
               ],
    "pfosten":  [
                    {
                        "sku":  "Holzpfosten_Laerche_VL10_80",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                        "laenge_cm":  80,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL10 (9 cm x 9 cm)",
                        "option2":  "80 cm",
                        "option3":  "",
                        "preis":  24.16
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL10_100",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                        "laenge_cm":  100,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL10 (9 cm x 9 cm)",
                        "option2":  "100 cm",
                        "option3":  "",
                        "preis":  30.82
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL10_120",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                        "laenge_cm":  120,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL10 (9 cm x 9 cm)",
                        "option2":  "120 cm",
                        "option3":  "",
                        "preis":  35.94
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL10_150",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                        "laenge_cm":  150,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL10 (9 cm x 9 cm)",
                        "option2":  "150 cm",
                        "option3":  "",
                        "preis":  47.60
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL10_180",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                        "laenge_cm":  180,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL10 (9 cm x 9 cm)",
                        "option2":  "180 cm",
                        "option3":  "",
                        "preis":  54.26
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL10_200",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL10",
                        "laenge_cm":  200,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL10 (9 cm x 9 cm)",
                        "option2":  "200 cm",
                        "option3":  "",
                        "preis":  60.10
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL12_80",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                        "laenge_cm":  80,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL12 (11 cm x 11 cm)",
                        "option2":  "80 cm",
                        "option3":  "",
                        "preis":  35.11
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL12_100",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                        "laenge_cm":  100,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL12 (11 cm x 11 cm)",
                        "option2":  "100 cm",
                        "option3":  "",
                        "preis":  43.44
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL12_120",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                        "laenge_cm":  120,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL12 (11 cm x 11 cm)",
                        "option2":  "120 cm",
                        "option3":  "",
                        "preis":  52.60
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL12_150",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                        "laenge_cm":  150,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL12 (11 cm x 11 cm)",
                        "option2":  "150 cm",
                        "option3":  "",
                        "preis":  65.33
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL12_180",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                        "laenge_cm":  180,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL12 (11 cm x 11 cm)",
                        "option2":  "180 cm",
                        "option3":  "",
                        "preis":  78.78
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VL12_200",
                        "ausfuehrung":  "Holzpfosten_Laerche_VL12",
                        "laenge_cm":  200,
                        "handle":  "vierkantholzpfosten-aus-larche",
                        "option1":  "VL12 (11 cm x 11 cm)",
                        "option2":  "200 cm",
                        "option3":  "",
                        "preis":  87.11
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_60",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "60",
                        "preis":  62.36
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_70",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "70",
                        "preis":  62.36
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_80",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "80",
                        "preis":  63.55
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_90",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "90",
                        "preis":  64.50
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_100",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "100",
                        "preis":  64.62
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_110",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "110",
                        "preis":  68.55
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_D_120",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_D",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "120",
                        "preis":  68.91
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_60",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "60",
                        "preis":  47.60
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_70",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "70",
                        "preis":  47.60
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_80",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "80",
                        "preis":  48.79
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_90",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "90",
                        "preis":  49.74
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_100",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "100",
                        "preis":  49.86
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_110",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "110",
                        "preis":  53.79
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL10_T_120",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL10_T",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "120",
                        "preis":  54.15
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_60",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "60",
                        "preis":  66.53
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_70",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "70",
                        "preis":  67.72
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_80",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "80",
                        "preis":  69.50
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_90",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "90",
                        "preis":  75.45
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_100",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "100",
                        "preis":  77.24
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_110",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "110",
                        "preis":  80.69
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_D_120",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_D",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "120",
                        "preis":  82.11
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_60",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "60",
                        "preis":  51.77
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_70",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "70",
                        "preis":  52.96
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_80",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "80",
                        "preis":  54.74
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_90",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "90",
                        "preis":  60.69
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_100",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "100",
                        "preis":  62.48
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_110",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "110",
                        "preis":  65.93
                    },
                    {
                        "sku":  "Holzpfosten_Laerche_VSL12_T_120",
                        "ausfuehrung":  "Holzpfosten_Laerche_VSL12_T",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-larche-unbehandelt-inkl-t-eisen-befestigung-ipf-system-kopie",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "120",
                        "preis":  67.35
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_60",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "60",
                        "preis":  49.39
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_70",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "70",
                        "preis":  49.39
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_80",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "80",
                        "preis":  50.10
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_90",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "90",
                        "preis":  50.94
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_100",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "100",
                        "preis":  50.94
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_110",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "110",
                        "preis":  54.15
                    },
                    {
                        "sku":  "Holzpfosten_VS10_D_120",
                        "ausfuehrung":  "Holzpfosten_VS10_D",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "120",
                        "preis":  54.63
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_60",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "60",
                        "preis":  35.70
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_70",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "70",
                        "preis":  35.70
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_80",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "80",
                        "preis":  36.41
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_90",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "90",
                        "preis":  37.25
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_100",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "100",
                        "preis":  37.25
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_110",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "110",
                        "preis":  40.46
                    },
                    {
                        "sku":  "Holzpfosten_VS10_T_120",
                        "ausfuehrung":  "Holzpfosten_VS10_T",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "9 cm x 9 cm",
                        "option3":  "120",
                        "preis":  40.94
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_60",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "60",
                        "preis":  52.01
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_70",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "70",
                        "preis":  52.96
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_80",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "80",
                        "preis":  54.15
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_90",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "90",
                        "preis":  59.51
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_100",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "100",
                        "preis":  59.51
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_110",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "110",
                        "preis":  63.08
                    },
                    {
                        "sku":  "Holzpfosten_VS12_D_120",
                        "ausfuehrung":  "Holzpfosten_VS12_D",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Aufdübeln",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "120",
                        "preis":  64.50
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_60",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  60,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "60",
                        "preis":  38.32
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_70",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  70,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "70",
                        "preis":  39.27
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_80",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  80,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "80",
                        "preis":  40.46
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_90",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  90,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "90",
                        "preis":  45.82
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_100",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  100,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "100",
                        "preis":  45.82
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_110",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  110,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "110",
                        "preis":  49.39
                    },
                    {
                        "sku":  "Holzpfosten_VS12_T_120",
                        "ausfuehrung":  "Holzpfosten_VS12_T",
                        "laenge_cm":  120,
                        "handle":  "zaunpfosten-fichte-kdi-inkl-t-eisen-befestigung-ipf-system",
                        "option1":  "Einbetonieren",
                        "option2":  "11 cm x 11 cm",
                        "option3":  "120",
                        "preis":  50.81
                    },
                    {
                        "sku":  "T-Eisenpfosten_14B_80",
                        "ausfuehrung":  "T-Eisenpfosten_14B",
                        "laenge_cm":  80,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14B",
                        "option2":  "80 cm",
                        "option3":  "",
                        "preis":  39.15
                    },
                    {
                        "sku":  "T-Eisenpfosten_14B_100",
                        "ausfuehrung":  "T-Eisenpfosten_14B",
                        "laenge_cm":  100,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14B",
                        "option2":  "100 cm",
                        "option3":  "",
                        "preis":  45.46
                    },
                    {
                        "sku":  "T-Eisenpfosten_14B_120",
                        "ausfuehrung":  "T-Eisenpfosten_14B",
                        "laenge_cm":  120,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14B",
                        "option2":  "120 cm",
                        "option3":  "",
                        "preis":  53.31
                    },
                    {
                        "sku":  "T-Eisenpfosten_14B_130",
                        "ausfuehrung":  "T-Eisenpfosten_14B",
                        "laenge_cm":  130,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14B",
                        "option2":  "130 cm",
                        "option3":  "",
                        "preis":  64.00
                    },
                    {
                        "sku":  "T-Eisenpfosten_14B_140",
                        "ausfuehrung":  "T-Eisenpfosten_14B",
                        "laenge_cm":  140,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14B",
                        "option2":  "140 cm",
                        "option3":  "",
                        "preis":  66.67
                    },
                    {
                        "sku":  "T-Eisenpfosten_14B_150",
                        "ausfuehrung":  "T-Eisenpfosten_14B",
                        "laenge_cm":  150,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14B",
                        "option2":  "150 cm",
                        "option3":  "",
                        "preis":  69.34
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_60",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  60,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "60 cm",
                        "option3":  "",
                        "preis":  37.72
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_70",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  70,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "70 cm",
                        "option3":  "",
                        "preis":  39.15
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_80",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  80,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "80 cm",
                        "option3":  "",
                        "preis":  40.70
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_90",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  90,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "90 cm",
                        "option3":  "",
                        "preis":  44.27
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_100",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  100,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "100 cm",
                        "option3":  "",
                        "preis":  46.89
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_120",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  120,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "120 cm",
                        "option3":  "",
                        "preis":  54.86
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_130",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  130,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "130 cm",
                        "option3":  "",
                        "preis":  65.82
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_140",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  140,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "140 cm",
                        "option3":  "",
                        "preis":  68.55
                    },
                    {
                        "sku":  "T-Eisenpfosten_14C_150",
                        "ausfuehrung":  "T-Eisenpfosten_14C",
                        "laenge_cm":  150,
                        "handle":  "t-eisenpfosten",
                        "option1":  "14C",
                        "option2":  "150 cm",
                        "option3":  "",
                        "preis":  71.30
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_70",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  70,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "70 cm",
                        "option3":  "",
                        "preis":  14.28
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_80",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  80,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "80 cm",
                        "option3":  "",
                        "preis":  14.64
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_90",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  90,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "90 cm",
                        "option3":  "",
                        "preis":  15.35
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_100",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  100,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "100 cm",
                        "option3":  "",
                        "preis":  16.07
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_110",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  110,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "110 cm",
                        "option3":  "",
                        "preis":  17.49
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_120",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  120,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "120 cm",
                        "option3":  "",
                        "preis":  19.16
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_130",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  130,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "130 cm",
                        "option3":  "",
                        "preis":  21.66
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_150",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  150,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "150 cm",
                        "option3":  "",
                        "preis":  24.04
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_180",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  180,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "180 cm",
                        "option3":  "",
                        "preis":  27.49
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V10_240",
                        "ausfuehrung":  "Vierkantholzpfosten_V10",
                        "laenge_cm":  240,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V10 (9 cm x 9 cm)",
                        "option2":  "240 cm",
                        "option3":  "",
                        "preis":  30.58
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_70",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  70,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "70 cm",
                        "option3":  "",
                        "preis":  16.42
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_80",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  80,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "80 cm",
                        "option3":  "",
                        "preis":  16.78
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_90",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  90,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "90 cm",
                        "option3":  "",
                        "preis":  18.92
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_100",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  100,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "100 cm",
                        "option3":  "",
                        "preis":  21.06
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_110",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  110,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "110 cm",
                        "option3":  "",
                        "preis":  23.32
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_120",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  120,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "120 cm",
                        "option3":  "",
                        "preis":  25.47
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_130",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  130,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "130 cm",
                        "option3":  "",
                        "preis":  28.56
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_150",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  150,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "150 cm",
                        "option3":  "",
                        "preis":  31.89
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_180",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  180,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "180 cm",
                        "option3":  "",
                        "preis":  38.20
                    },
                    {
                        "sku":  "Vierkantholzpfosten_V12_240",
                        "ausfuehrung":  "Vierkantholzpfosten_V12",
                        "laenge_cm":  240,
                        "handle":  "vierkantholzpfosten-aus-fichte-kdi",
                        "option1":  "V12 (11 cm x 11 cm)",
                        "option2":  "240 cm",
                        "option3":  "",
                        "preis":  48.79
                    }
                ],
    "halter":  [
                   {
                       "sku":  "Pfostenhalter_DUP_110_15",
                       "ausfuehrung":  "Pfostenhalter_DUP_110",
                       "laenge_cm":  15,
                       "handle":  "dubelplatten-pfostenhalter-feuerverzinkter-stahl",
                       "option1":  "Innendurchmesser 11.1 cm",
                       "preis":  10.47
                   },
                   {
                       "sku":  "Pfostenhalter_DUP_90_15",
                       "ausfuehrung":  "Pfostenhalter_DUP_90",
                       "laenge_cm":  15,
                       "handle":  "dubelplatten-pfostenhalter-feuerverzinkter-stahl",
                       "option1":  "Innendurchmesser 9.1 cm",
                       "preis":  10.36
                   },
                   {
                       "sku":  "Pfostenhalter_HS_11_60_60",
                       "ausfuehrung":  "Pfostenhalter_HS_11_60",
                       "laenge_cm":  60,
                       "handle":  "h-steg-pfostentrager",
                       "option1":  "Länge: 60 cm / Abstand innen: 11.1 cm",
                       "preis":  18.45
                   },
                   {
                       "sku":  "Pfostenhalter_HS_9_60_60",
                       "ausfuehrung":  "Pfostenhalter_HS_9_60",
                       "laenge_cm":  60,
                       "handle":  "h-steg-pfostentrager",
                       "option1":  "Länge: 60 cm / Abstand innen: 9.1 cm",
                       "preis":  16.07
                   },
                   {
                       "sku":  "Pfostenhalter_HS_9_80_80",
                       "ausfuehrung":  "Pfostenhalter_HS_9_80",
                       "laenge_cm":  80,
                       "handle":  "h-steg-pfostentrager",
                       "option1":  "Länge: 80 cm / Abstand innen: 9.1 cm",
                       "preis":  22.02
                   }
               ],
    "kappen":  [
                   {
                       "sku":  "Pfostenkappe_100x100_FV_Stk",
                       "ausfuehrung":  "Pfostenkappe_100x100_FV",
                       "handle":  "pfostenkappen-mit-pyramidenspitze",
                       "option1":  "100 mm x 100 mm",
                       "preis":  7.38
                   },
                   {
                       "sku":  "Pfostenkappe_120x120_FV_Stk",
                       "ausfuehrung":  "Pfostenkappe_120x120_FV",
                       "handle":  "pfostenkappen-mit-pyramidenspitze",
                       "option1":  "120 mm x 120 mm",
                       "preis":  8.33
                   },
                   {
                       "sku":  "Pfostenkappe_155x155_FV_Stk",
                       "ausfuehrung":  "Pfostenkappe_155x155_FV",
                       "handle":  "pfostenkappen-mit-pyramidenspitze",
                       "option1":  "155 mm x 155 mm",
                       "preis":  11.31
                   },
                   {
                       "sku":  "Pfostenkappe_60x60_FV_Stk",
                       "ausfuehrung":  "Pfostenkappe_60x60_FV",
                       "handle":  "pfostenkappen-mit-pyramidenspitze",
                       "option1":  "60 mm x 60 mm",
                       "preis":  5.95
                   },
                   {
                       "sku":  "Pfostenkappe_80x80_FV_Stk",
                       "ausfuehrung":  "Pfostenkappe_80x80_FV",
                       "handle":  "pfostenkappen-mit-pyramidenspitze",
                       "option1":  "80 mm x 80 mm",
                       "preis":  6.55
                   }
               ],
    "winkel":  [
                   {
                       "sku":  "Zaunzubehoer_Zaunwinkel_Stk",
                       "ausfuehrung":  "Zaunzubehoer_Zaunwinkel",
                       "handle":  "zaunwinkel",
                       "option1":  "Default Title",
                       "preis":  4.16
                   }
               ],
    "latten_artikel":  [
                           {
                               "sku":  "Hobellattenzaun_12A_60",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  60,
                               "preis":  2.3115,
                               "gewicht_kg":  0.44
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_70",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  70,
                               "preis":  2.6335,
                               "gewicht_kg":  0.51
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_80",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  80,
                               "preis":  2.875,
                               "gewicht_kg":  0.59
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_90",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  90,
                               "preis":  3.105,
                               "gewicht_kg":  0.66
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_100",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  100,
                               "preis":  3.335,
                               "gewicht_kg":  0.73
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_110",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  110,
                               "preis":  3.611,
                               "gewicht_kg":  0.81
                           },
                           {
                               "sku":  "Hobellattenzaun_12A_120",
                               "ausfuehrung":  "Hobellattenzaun_12A",
                               "laenge_cm":  120,
                               "preis":  4.002,
                               "gewicht_kg":  0.88
                           },
                           {
                               "sku":  "Knueppelzaun_1R_60",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  60,
                               "preis":  2.116,
                               "gewicht_kg":  0.27
                           },
                           {
                               "sku":  "Knueppelzaun_1R_70",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  70,
                               "preis":  2.2195,
                               "gewicht_kg":  0.32
                           },
                           {
                               "sku":  "Knueppelzaun_1R_80",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  80,
                               "preis":  2.438,
                               "gewicht_kg":  0.36
                           },
                           {
                               "sku":  "Knueppelzaun_1R_90",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  90,
                               "preis":  2.599,
                               "gewicht_kg":  0.41
                           },
                           {
                               "sku":  "Knueppelzaun_1R_100",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  100,
                               "preis":  2.714,
                               "gewicht_kg":  0.45
                           },
                           {
                               "sku":  "Knueppelzaun_1R_110",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  110,
                               "preis":  2.852,
                               "gewicht_kg":  0.5
                           },
                           {
                               "sku":  "Knueppelzaun_1R_120",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  120,
                               "preis":  3.059,
                               "gewicht_kg":  0.54
                           },
                           {
                               "sku":  "Knueppelzaun_1R_130",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  130,
                               "preis":  3.289,
                               "gewicht_kg":  0.59
                           },
                           {
                               "sku":  "Knueppelzaun_1R_140",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  140,
                               "preis":  3.5075,
                               "gewicht_kg":  0.63
                           },
                           {
                               "sku":  "Knueppelzaun_1R_150",
                               "ausfuehrung":  "Knueppelzaun_1R",
                               "laenge_cm":  150,
                               "preis":  3.749,
                               "gewicht_kg":  0.68
                           },
                           {
                               "sku":  "Quadratzaun_4K_60",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  60,
                               "preis":  2.3115,
                               "gewicht_kg":  0.35
                           },
                           {
                               "sku":  "Quadratzaun_4K_70",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  70,
                               "preis":  2.507,
                               "gewicht_kg":  0.4
                           },
                           {
                               "sku":  "Quadratzaun_4K_80",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  80,
                               "preis":  2.691,
                               "gewicht_kg":  0.46
                           },
                           {
                               "sku":  "Quadratzaun_4K_90",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  90,
                               "preis":  3.1395,
                               "gewicht_kg":  0.52
                           },
                           {
                               "sku":  "Quadratzaun_4K_100",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  100,
                               "preis":  3.197,
                               "gewicht_kg":  0.58
                           },
                           {
                               "sku":  "Quadratzaun_4K_110",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  110,
                               "preis":  3.703,
                               "gewicht_kg":  0.63
                           },
                           {
                               "sku":  "Quadratzaun_4K_120",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  120,
                               "preis":  3.91,
                               "gewicht_kg":  0.69
                           },
                           {
                               "sku":  "Quadratzaun_4K_130",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  130,
                               "preis":  4.531,
                               "gewicht_kg":  0.75
                           },
                           {
                               "sku":  "Quadratzaun_4K_140",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  140,
                               "preis":  4.7035,
                               "gewicht_kg":  0.81
                           },
                           {
                               "sku":  "Quadratzaun_4K_150",
                               "ausfuehrung":  "Quadratzaun_4K",
                               "laenge_cm":  150,
                               "preis":  5.0715,
                               "gewicht_kg":  0.86
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_60",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  60,
                               "preis":  3.151,
                               "gewicht_kg":  0.46
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_70",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  70,
                               "preis":  3.335,
                               "gewicht_kg":  0.54
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_80",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  80,
                               "preis":  3.5305,
                               "gewicht_kg":  0.61
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_90",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  90,
                               "preis":  4.232,
                               "gewicht_kg":  0.69
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_100",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  100,
                               "preis":  4.278,
                               "gewicht_kg":  0.76
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_110",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  110,
                               "preis":  4.7955,
                               "gewicht_kg":  0.84
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_120",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  120,
                               "preis":  5.014,
                               "gewicht_kg":  0.92
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_130",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  130,
                               "preis":  5.6235,
                               "gewicht_kg":  0.99
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_140",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  140,
                               "preis":  5.7385,
                               "gewicht_kg":  1.07
                           },
                           {
                               "sku":  "Quadratzaun_Laerche_32A_150",
                               "ausfuehrung":  "Quadratzaun_Laerche_32A",
                               "laenge_cm":  150,
                               "preis":  6.164,
                               "gewicht_kg":  1.15
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_60",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  60,
                               "preis":  1.7135,
                               "gewicht_kg":  0.45
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_70",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  70,
                               "preis":  1.7365,
                               "gewicht_kg":  0.53
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_80",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  80,
                               "preis":  1.7595,
                               "gewicht_kg":  0.6
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_90",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  90,
                               "preis":  1.932,
                               "gewicht_kg":  0.68
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_100",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  100,
                               "preis":  2.001,
                               "gewicht_kg":  0.76
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_110",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  110,
                               "preis":  2.3115,
                               "gewicht_kg":  0.83
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_120",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  120,
                               "preis":  2.4265,
                               "gewicht_kg":  0.91
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_130",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  130,
                               "preis":  2.783,
                               "gewicht_kg":  0.98
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_140",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  140,
                               "preis":  3.151,
                               "gewicht_kg":  1.06
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_2C_150",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_2C",
                               "laenge_cm":  150,
                               "preis":  3.381,
                               "gewicht_kg":  1.13
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_60",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  60,
                               "preis":  1.7365,
                               "gewicht_kg":  0.45
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_70",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  70,
                               "preis":  1.8975,
                               "gewicht_kg":  0.53
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_80",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  80,
                               "preis":  1.909,
                               "gewicht_kg":  0.6
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_90",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  90,
                               "preis":  1.9665,
                               "gewicht_kg":  0.68
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_100",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  100,
                               "preis":  2.093,
                               "gewicht_kg":  0.76
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_110",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  110,
                               "preis":  2.438,
                               "gewicht_kg":  0.83
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_120",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  120,
                               "preis":  2.507,
                               "gewicht_kg":  0.91
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_130",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  130,
                               "preis":  2.9095,
                               "gewicht_kg":  0.98
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_140",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  140,
                               "preis":  3.289,
                               "gewicht_kg":  1.06
                           },
                           {
                               "sku":  "Senkrechter_Lattenzaun_3E_150",
                               "ausfuehrung":  "Senkrechter_Lattenzaun_3E",
                               "laenge_cm":  150,
                               "preis":  3.45,
                               "gewicht_kg":  1.13
                           }
                       ],
    "riegel_artikel":  [
                           {
                               "sku":  "Querriegel_B_100",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  100,
                               "preis":  3.7605,
                               "gewicht_kg":  1.43
                           },
                           {
                               "sku":  "Querriegel_B_200",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  200,
                               "preis":  7.5095,
                               "gewicht_kg":  2.86
                           },
                           {
                               "sku":  "Querriegel_B_230",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  230,
                               "preis":  8.6365,
                               "gewicht_kg":  3.29
                           },
                           {
                               "sku":  "Querriegel_B_250",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  250,
                               "preis":  9.3955,
                               "gewicht_kg":  3.57
                           },
                           {
                               "sku":  "Querriegel_B_300",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  300,
                               "preis":  11.27,
                               "gewicht_kg":  4.29
                           },
                           {
                               "sku":  "Querriegel_B_400",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  400,
                               "preis":  17.756,
                               "gewicht_kg":  5.72
                           },
                           {
                               "sku":  "Querriegel_B_500",
                               "ausfuehrung":  "Querriegel_B",
                               "laenge_cm":  500,
                               "preis":  22.2065,
                               "gewicht_kg":  7.15
                           },
                           {
                               "sku":  "Vierkantriegel_A_100",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  100,
                               "preis":  5.129,
                               "gewicht_kg":  1.41
                           },
                           {
                               "sku":  "Vierkantriegel_A_200",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  200,
                               "preis":  10.2465,
                               "gewicht_kg":  2.82
                           },
                           {
                               "sku":  "Vierkantriegel_A_230",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  230,
                               "preis":  11.7875,
                               "gewicht_kg":  3.24
                           },
                           {
                               "sku":  "Vierkantriegel_A_250",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  250,
                               "preis":  12.811,
                               "gewicht_kg":  3.52
                           },
                           {
                               "sku":  "Vierkantriegel_A_300",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  300,
                               "preis":  15.3755,
                               "gewicht_kg":  4.23
                           },
                           {
                               "sku":  "Vierkantriegel_A_400",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  400,
                               "preis":  24.587,
                               "gewicht_kg":  5.64
                           },
                           {
                               "sku":  "Vierkantriegel_A_500",
                               "ausfuehrung":  "Vierkantriegel_A",
                               "laenge_cm":  500,
                               "preis":  30.7395,
                               "gewicht_kg":  7.05
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_50",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  50,
                               "preis":  4.7725,
                               "gewicht_kg":  1.22
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_100",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  100,
                               "preis":  9.5565,
                               "gewicht_kg":  2.43
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_150",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  150,
                               "preis":  14.3405,
                               "gewicht_kg":  3.65
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_200",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  200,
                               "preis":  19.1245,
                               "gewicht_kg":  4.87
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_220",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  220,
                               "preis":  21.0335,
                               "gewicht_kg":  5.35
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_230",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  230,
                               "preis":  21.9995,
                               "gewicht_kg":  5.6
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_240",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  240,
                               "preis":  22.954,
                               "gewicht_kg":  5.84
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_250",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  250,
                               "preis":  23.9085,
                               "gewicht_kg":  6.08
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_300",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  300,
                               "preis":  28.6925,
                               "gewicht_kg":  7.3
                           },
                           {
                               "sku":  "Vierkantriegel_Laerche_LV_400",
                               "ausfuehrung":  "Vierkantriegel_Laerche_LV",
                               "laenge_cm":  400,
                               "preis":  38.249,
                               "gewicht_kg":  9.73
                           }
                       ],
    "latten":  [
                   {
                       "name":  "Quadratzaun_4K",
                       "variante":  "4K",
                       "breite_cm":  3.5,
                       "anzahl_pro_m":  12.5,
                       "form":  "Quader",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Hobellattenzaun_12A",
                       "variante":  "12A",
                       "breite_cm":  6.5,
                       "anzahl_pro_m":  9,
                       "form":  "Quader",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Knueppelzaun_1R",
                       "variante":  "1R",
                       "breite_cm":  3.5,
                       "anzahl_pro_m":  12,
                       "form":  "Zylinder",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Quadratzaun_Laerche_32A",
                       "variante":  "32A",
                       "breite_cm":  3.6,
                       "anzahl_pro_m":  12,
                       "form":  "Quader",
                       "material":  "Laerche"
                   },
                   {
                       "name":  "Senkrechter_Lattenzaun_2C",
                       "variante":  "2C",
                       "breite_cm":  6.4,
                       "anzahl_pro_m":  9,
                       "form":  "halbrund",
                       "material":  "Fichte"
                   },
                   {
                       "name":  "Senkrechter_Lattenzaun_3E",
                       "variante":  "3E",
                       "breite_cm":  6.4,
                       "anzahl_pro_m":  9,
                       "form":  "halbrund",
                       "material":  "Fichte"
                   }
               ]
};
